import React, { useEffect, useState } from 'react'

function gtag () {
  if (!window.hasOwnProperty('dataLayer')) {
    return
  }
  window.dataLayer.push(arguments)
}

const useGoogleAnalytics = (trackingId) => {
  const [loaded, setLoaded] = useState(false)

  const sendPageView = React.useCallback((locationPathname) => {
    // obsolete // we assume that gtag tracks location changes itself
    // if (locationPathname) {
    //   gtag('send', 'pageview', locationPathname)
    // } else {
    //   gtag('send', 'pageview')
    // }
  }, [])

  const injectGA = (trackingId) => {
    if (typeof window == 'undefined') {
      return
    }
    window.dataLayer = window.dataLayer || []

    gtag('js', new Date())
    gtag('config', trackingId)
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.setAttribute('data-ccm-loader-src', 'https://www.googletagmanager.com/gtag/js?id=' + trackingId)
    script.setAttribute('type', 'text/x-ccm-loader')
    script.setAttribute('data-ccm-loader-group', 'data-ccm-loader-group-ga')
    script.addEventListener('load', () => {
      setLoaded(true)
      // sendPageView(undefined)
    })
    injectGA(trackingId)
    document.body.appendChild(script)
  }, [trackingId, sendPageView])

  return {
    loaded,
    sendPageView
  }
}

export default useGoogleAnalytics
